import $ from 'jquery'
import { ajax, localize, notify, event } from 'linksoft'

const resx = localize("App", "Common");

$(document).on('click', '.dataTable [data-control-button-delete]', function () {
    const $deleteBtn = $(this);
    const itemId = $deleteBtn.attr('data-control-button-delete');
    if (!itemId) return;
    const $table = $deleteBtn.closest('.dataTable');
    if ($table.length > 0) {
        const api = $table.DataTable();
        const url = correctUrl(api.init().ajax.url);
        const deleteUrl = `${url}(${itemId})`;
        ajax({ url: deleteUrl, method: 'DELETE' }).done(result => {
            notify.success(resx.Common.DeleteSuccess);
            api.ajax.reload(null, false);
            event.trigger('siisel.datatable.updated.' + $table.attr('id'));
        });
    }
});

var correctUrl = function (url) {
    var correctUrl = url;
    if (url.indexOf('?') > -1) {
        correctUrl = url.substring(0, url.indexOf('?'));
    }
    return correctUrl;
}


// WEBPACK FOOTER //
// ./App/config/dt-control-buttons.js